import React from 'react';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import i18next from 'i18next';

import RestSelect from 'components/RestInput/RestSelect';
import InfiniteAutoComplete from 'components/InfiniteFormItem/InfiniteAutoComplete';
import { useTranslation } from 'react-i18next';
import RestRangePickerInput from 'components/RestInput/RestRangePickerInput';
import { FORMAT_DATE_PICKER } from 'configs/localData/constant';
import moment from 'moment';
import FormSelectCheckbox from 'components/form/FormSelectCheckbox';
import {
  useContactConfigUserEmailControllerGetUserEmailConfigQuery,
  useContactConfigUserNameControllerGetUserNameConfigQuery,
  useContactConfigUserPhoneControllerGetUserPhoneConfigQuery,
  useCrmContactsConfigControllerGetCrmContactConfigQuery,
} from 'generated/apis';
import { disabledDate } from 'containers/Contacts/utils';

const ContactFilterForm = () => {
  const { t } = useTranslation();

  const { data } = useCrmContactsConfigControllerGetCrmContactConfigQuery();

  const rangesFooterCustom = {
    [i18next.t('dateTimePickerText.today')]: [
      moment().startOf('day'),
      moment().endOf('day'),
    ],
    [i18next.t('dateTimePickerText.yesterday')]: [
      moment().subtract(1, 'days').startOf('day'),
      moment().subtract(1, 'days').endOf('day'),
    ],
    [i18next.t('dateTimePickerText.last7Days')]: [
      moment().subtract(7, 'days').startOf('day'),
      moment().subtract(1, 'days').endOf('day'),
    ],
    [i18next.t('dateTimePickerText.last30Days')]: [
      moment().subtract(30, 'days').startOf('day'),
      moment().subtract(1, 'days').endOf('day'),
    ],
    [i18next.t('dateTimePickerText.last12Months')]: [
      moment().subtract(1, 'days').subtract(12, 'months').startOf('day'),
      moment().subtract(1, 'days').endOf('day'),
    ],
  };

  return (
    <Row gutter={16}>
      <Col xl={6} lg={8} md={12} xs={24}>
        <InfiniteAutoComplete
          name="userName"
          showSearch
          filterOption={false}
          useQuery={useContactConfigUserNameControllerGetUserNameConfigQuery}
          placeholder={t('contacts.parentGuardianJobSeekerName')}
          labelProp="fullName"
          valueProp="fullName"
        />
      </Col>
      <Col xl={6} lg={8} md={12} xs={24}>
        <InfiniteAutoComplete
          name="userEmail"
          showSearch
          filterOption={false}
          useQuery={useContactConfigUserEmailControllerGetUserEmailConfigQuery}
          placeholder={t('contacts.email')}
          labelProp="email"
          valueProp="email"
        />
      </Col>
      <Col xl={6} lg={8} md={12} xs={24}>
        <InfiniteAutoComplete
          name="userPhone"
          showSearch
          filterOption={false}
          useQuery={useContactConfigUserPhoneControllerGetUserPhoneConfigQuery}
          placeholder={t('contacts.phone')}
          labelProp="phoneNumber"
          valueProp="phoneNumber"
        />
      </Col>
      <Col xl={6} lg={8} md={12} xs={24}>
        <FormSelectCheckbox
          isShowTooltip
          name="activity"
          valueProp="value"
          labelProp="text"
          placeholder={t('contacts.contactCreatedReason')}
          data={Object.values(data?.activity || {})}
          dropdownMatchSelectWidth={false}
          className="form-select-checkbox"
        />
      </Col>
      <Col xl={6} lg={8} md={12} xs={24}>
        <RestSelect
          isShowTooltip
          source="contactType"
          placeholder="contacts.contactType"
          valueProp="value"
          titleProp="text"
          resourceData={data?.type}
          formatText={(value) => t(value as string)}
        />
      </Col>
      <Col xl={6} lg={8} md={12} xs={24}>
        <RestRangePickerInput
          source="lastActiveAt"
          placeholder="common.lastActiveAt"
          isShowTooltip
          sourceGt="lastActiveAt.from"
          sourceLt="lastActiveAt.to"
          isShowRangesFooter
          rangesFooterCustom={rangesFooterCustom}
          disabledDate={disabledDate}
          formatDate={FORMAT_DATE_PICKER}
        />
      </Col>
      <Col xl={6} lg={8} md={12} xs={24}>
        <RestRangePickerInput
          source="createdAt"
          placeholder="common.createdAt"
          isShowTooltip
          sourceGt="createdAt.from"
          sourceLt="createdAt.to"
          isShowRangesFooter
          rangesFooterCustom={rangesFooterCustom}
          disabledDate={disabledDate}
          formatDate={FORMAT_DATE_PICKER}
        />
      </Col>
    </Row>
  );
};

export default ContactFilterForm;
